module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Frontmatter"
    }
  }, [_c('p', {
    staticClass: "fm-para1"
  }, [_vm._v("By the same author")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("The Spice of Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("Flying the Waves")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("Beaufighter Ace")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("Seven Seas, Nine Lives")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("Moose’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("The Lightning Boys")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("Alfie’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("The Lightning Boys 2")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_c('i', [_vm._v("Hunter Boys")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c35be0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Frontmatter.vue
// module id = 57
// module chunks = 0